var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Material/Icons/\uC624\uB354") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Material/Icons/\\uC624\\uB354",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u110C\\u1161\\u1109\\u1161\\u11AB-40",
    transform: "translate(0.000000, 1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.460423, 0.000000)",
    fill: "#BF6E58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.55376382,4.89448484 L1.83413268,4.89448484 L0.144471391,1.76627062 C-0.170478068,1.18531655 0.0465816943,0.459655967 0.629663801,0.144706508 C0.810546936,0.0468168115 1.00632633,1.18129777e-16 1.19784965,1.18129777e-16 C1.62345703,1.18129777e-16 2.03629618,0.227699947 2.25335595,0.629898918 L4.55589186,4.89448484 L4.55376382,4.89448484 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.52539,4.89448484 L15.2450211,4.89448484 L16.9346824,1.76627062 C17.2496319,1.18531655 17.0325721,0.459655967 16.44949,0.144706508 C16.2686069,0.0468168115 16.0728275,0 15.8813042,0 C15.4556968,0 15.0428576,0.227699947 14.8257979,0.629898918 L12.523262,4.89448484 L12.52539,4.89448484 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24,8.23975882 C24,8.83986522 23.7595318,9.38464267 23.3701011,9.77620145 C22.9806703,10.1720163 22.442277,10.4146125 21.8485547,10.4146125 L2.14931725,10.4146125 C0.959744636,10.4146125 0,9.43997163 0,8.23975882 C0,7.63965242 0.240468168,7.09487498 0.629898918,6.70118815 C1.01932967,6.30750133 1.55559496,6.06490513 2.14931725,6.06490513 L21.8485547,6.06490513 C23.0381273,6.06490513 23.997872,7.03741798 23.997872,8.23975882 L24,8.23975882 Z",
    id: "Path",
    fill: "#FFE98A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.525802, 11.587161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9262281,9.89324348 L5.02003901,9.89324348 C3.70278418,9.89324348 2.54513212,9.01862032 2.18762192,7.75031034 L0,0 L20.9462671,0 L18.7586451,7.75031034 C18.401135,9.01862032 17.2434829,9.89324348 15.9262281,9.89324348 Z",
    id: "Path",
    fill: "#F95F53"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 9.61021458,
    y: 1.92587338,
    width: 1.72796595,
    height: 6.04149672,
    rx: 0.863982976
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31917765,1.95118106 C6.79634227,1.95118106 7.18316062,2.33799942 7.18316062,2.81516404 L7.18316062,7.12869481 C7.18316062,7.60585943 6.79634227,7.99267778 6.31917765,7.99267778 C5.84201303,7.99267778 5.45519467,7.60585943 5.45519467,7.12869481 L5.45519467,2.81516404 C5.45519467,2.33799942 5.84201303,1.95118106 6.31917765,1.95118106 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(6.319178, 4.971929) rotate(-8.900000) translate(-6.319178, -4.971929) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6265839,1.95201368 C15.1037485,1.95201368 15.4905668,2.33883203 15.4905668,2.81599666 L15.4905668,7.12952742 C15.4905668,7.60669205 15.1037485,7.9935104 14.6265839,7.9935104 C14.1494192,7.9935104 13.7626009,7.60669205 13.7626009,7.12952742 L13.7626009,2.81599666 C13.7626009,2.33883203 14.1494192,1.95201368 14.6265839,1.95201368 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(14.626584, 4.972762) rotate(-171.100000) translate(-14.626584, -4.972762) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOrder);
export default __webpack_public_path__ + "static/media/menu_order.67f8a3c5ffef7eb4d9fab6517fd4e33f.svg";
export { ForwardRef as ReactComponent };